// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__xgEGi","modalFooterButton":"ModalNotes_modalFooterButton__1-ZlK"};